<template>
  <div>
    <ul>
      <template v-for="item in menuData">
        <li
          :class="item.elId !== index ? 'menu-default' : 'menu-active'"
          v-if="item.elId !== 'workbag'"
          :key="item.menuName"
          :index="item.elId"
        >
          <span @click="handleClick(item.elId)">{{ item.menuName }}</span>
        </li>
        <div
         :class="item.elId !== index ? 'menu-default' : 'menu-active'"
          :key="item.menuName"
          v-if="item.elId === 'workbag'"
          @mouseover="handleMouseOver"
          @mouseleave="handleMouseLeave"
        >
          <li href="#" class="dropbtn">{{item.menuName}}</li>
          <div id="myDropdown" class="dropdown-content">
            <el-col :span="4" class="dropdown-content-title" v-for="child in item.children" :key="child.elId">
              {{child.menuName}}
              <el-col class="dropdown-content-meun" v-for="littleChild in child.children" :key="littleChild.elId">
                <span @click="handleClick(littleChild.elId)">{{littleChild.menuName}}</span>
              </el-col>
            </el-col>
          </div>
        </div>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    menuData: {
      type: Array,
      default: () => []
    },
    index: {
      type: String
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('select', e)
      if (this.menuData.some(item => item.elId === e)) {
      } else {
        document.getElementById('myDropdown').style.display = 'none'
      }
    },
    handleMouseOver(e) {
      document.getElementById('myDropdown').style.display = 'block'
    },
    handleMouseLeave(e) {
      document.getElementById('myDropdown').style.display = 'none'
    }
  }
}
</script>
<style lang="stylus" scoped>
.menu-default, .menu-active,.dropdown
  color rgba(255, 255, 255, 0.65)
  font-size 14px
  font-weight 400
  cursor pointer
  padding 0 28px
.menu-active,.menu-default:hover,.dropdown:hover
  color rgba(255, 255, 255, 1)
  font-weight: 500
.dropdown
  display inline-block
.dropdown-content
  display none
  position absolute
  background-color #f9f9f9
  min-width 160px
  box-shadow 0px 5px 16px 0px rgba(0,0,0,0.2)
  z-index 999
  top 60px
  left  0
  width 100%
  height 180px
  line-height 20px
.dropdown-content li
  color black
  padding 12px 16px
  text-decoration none
  display block
.dropdown-content li:hover
  background-color: #f1f1f1
.dropdown:hover .dropdown-content
  display block
.dropdown-content-title
  color rgba(0,0,0,0.65)
  padding 15px
  font-size 18px
.dropdown-content-meun
  font-size 14px
  padding 10px 20px 0px 0
.dropdown-content-meun:nth-child(1)
  padding-top 15px
.dropdown-content-meun:hover
  color #ff8b00
.show {display:block;}
</style>
